module.exports = __webpack_public_path__ + "img/icn-handle.912d404c.svg";